import trackEvent, { ANALYTICS_EVENTS } from '../utilities/analytics';
import { CollectError, ErrorTracking, globalConfig } from '../config';
import { getMessageOrigin, isSubmitCallback } from './messages';

function onWindowMessage(message, callback) {
  window.addEventListener('message', (event) => {
    const { data } = event;
    const origin = getMessageOrigin(event);
    const { messageName, payload } = data;
    if (messageName === message) {
      callback(payload);
    }
  });
}

function sendMessage(domain, w, messageName, payload, callback) {
  try {
    w.postMessage({ messageName, fieldId: globalConfig.fieldId, payload }, domain);
    if (isSubmitCallback(messageName)) {
      trackEvent({
        type: ANALYTICS_EVENTS.POST_MESSAGE,
        status: 'Ok',
        messageName,
        domain,
      });
    }
  } catch (e) {
    const info = {
      domain,
      messageName,
      name: e && e.name,
      message: e && e.message,
    };
    ErrorTracking.error('postMessage crashed in iframe', e, info);
    trackEvent({
      type: ANALYTICS_EVENTS.POST_MESSAGE,
      status: 'Failed',
      ...info,
    });
  }
}

export function unsafeListen(messageName, callback) {
  return onWindowMessage(messageName, callback);
}

export function unsafeSend(...args) {
  return sendMessage('*', ...args);
}
